import * as React from 'react';
import { useState, useEffect, useCallback } from 'react';
import { map, get, isEmpty, size } from 'lodash';
import { __, redirect } from '../../../../core/utils';
import queryString from 'query-string';
import { connect } from 'react-redux';
import CloseMediumIcon from '../../../../assets/images/close-middle-15x15.svg';

import Tooltip from '../../../../components/Tooltip';
import Localization from '../../../../helpers/Localization';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';
import { isSafari } from 'react-device-detect';
import Dropdown from '../../../../components/Dropdown';
import ArrowDownSmallIcon from '../../../../assets/images/arrow-down-small-15x15.svg';
import { PlanChooser } from '../PlanChooser/PlanChooser';
import DualViewer from '../DualViewer/DualViewer';
import classNames from 'classnames';

// TODO: Create a new style for the ComparePlans component
import styles from '../../../../styles/views/plans/PlanVersionPreview.scss';

const ComparePlans = ({
  match,
  action,
  location,
  onInfoIconClick,
  planWidth,
  planHeight,
  leftTitleComponent,
  localization,
  compareByDiscipline = false,
  name,
}) => {
  const [firstPlan, setFirstPlan] = useState({});
  const [secondPlan, setSecondPlan] = useState({});

  const [activeTab, setActiveTab] = useState('plans');

  const [openChooser, setOpenChooser] = useState('');
  const [slotsVisible, setSlotsVisible] = useState({
    first: true,
    second: true,
  });

  const [originalPlans, setOriginalPlans] = useState([]);
  const [disciplinePlans, setDisciplinePlans] = useState([]);
  const [activePlans, setActivePlans] = useState([]);

  useEffect(() => {
    action().then(({ response }) => {
      const original_plans = response.data;
      setOriginalPlans(original_plans);
      setActivePlans(original_plans);

      if (size(original_plans) > 1) {
        // default tab = plans
        const firstPlan = original_plans[0];
        const secondPlan = original_plans[1];

        setFirstPlan(firstPlan);
        setSecondPlan(secondPlan);
      }

      compareByDiscipline().then(({ response }) => {
        setDisciplinePlans([
          ...map(response.data, (item) => {
            return {
              ...item,
              title: !item.discipline_id
                ? item.discipline_description + '*'
                : _.get(localization.disciplines, [item.discipline_id, 'name']),
            };
          }),
        ]);
      });
    });
  }, []);

  useEffect(() => {
    if (!isEmpty(disciplinePlans) && size(originalPlans) <= 1) {
      handleActiveTab('disciplines');
    }
  }, [disciplinePlans]);

  const _toggleCompareTool = () => {
    const compare = get(
      queryString.parse(location.search),
      'compare',
      undefined
    );

    redirect(
      {
        search: queryString.stringify({
          ...queryString.parse(location.search),
          compare: compare ? undefined : '1',
        }),
      },
      true
    );
  };

  const handleChangeFirstPlan = useCallback(
    (planId) => {
      const found = activePlans.find((p) => p?.id === planId);
      setFirstPlan(found);

      setOpenChooser('');
    },
    [activePlans]
  );

  const handleChangeSecondPlan = useCallback(
    (planId) => {
      const found = activePlans.find((p) => p?.id === planId);

      setSecondPlan(found);

      setOpenChooser('');
    },
    [activePlans]
  );

  const handleSlotSwitch = useCallback(
    (source) => {
      setSlotsVisible((prev) => ({ ...prev, [source]: !prev[source] }));
    },
    [activePlans]
  );

  const toggleChooser = useCallback((key) => {
    setOpenChooser((prev) => (prev === key ? '' : key));
  }, []);

  const handleActiveTab = (tab) => {
    setActiveTab(tab);
    setOpenChooser('');

    const data = tab === 'plans' ? originalPlans : disciplinePlans;
    setActivePlans(data);

    if (size(data) > 1) {
      const firstPlan = data[0];
      const secondPlan = data[1];
      setFirstPlan(firstPlan);
      setSecondPlan(secondPlan);
    }
  };

  const firstTitle = firstPlan?.title;
  const secondTitle = secondPlan?.title;

  return (
    <div className={styles.wrapper}>
      <div className={styles.toolbar}>
        <div className={styles.title}>
          {leftTitleComponent}
          {/* <div className={styles.left}>
            <div className={styles.back} onClick={_toggleCompareTool}>
              <Tooltip text={__('plans.tooltip.icon.back-to-list')}>
                <ArrowLeftMiddleIcon />
              </Tooltip>
            </div>

            <div className={styles.separator} />
          </div> */}
          {/* Plan title - Right side */}
          <div className={styles.right}>
            <div className={styles.comparePlansDropdown}>
              <Dropdown
                top={35}
                right={0}
                wrapperClassName={styles.dropdownWrapper}
                name={'compare_plans'}
                header={
                  <div className={styles.dropdownHeader}>
                    {__('plans.tooltip.icon.compare_plans')}
                  </div>
                }
                content={
                  <div className={styles.dropdownContent}>
                    {compareByDiscipline && (
                      <div className={styles.tabWrapper}>
                        <div
                          className={classNames(
                            styles.tab,
                            activeTab === 'plans' && styles.active
                          )}
                          onClick={() => handleActiveTab('plans')}
                        >
                          <span>{__('plans.compare.tab.plan.' + name)}</span>
                        </div>
                        <div
                          className={classNames(
                            styles.tab,
                            activeTab === 'disciplines' && styles.active
                          )}
                          onClick={() => handleActiveTab('disciplines')}
                        >
                          <span> {__('plans.compare.tab.discipline')}</span>
                        </div>
                      </div>
                    )}

                    {size(activePlans) > 1 && (
                      <>
                        <PlanChooser
                          label={firstTitle}
                          firstColor='#E74C3C'
                          items={activePlans}
                          activeFirstPlanId={firstPlan?.id}
                          activeSecondPlanId={secondPlan?.id}
                          isOpen={openChooser === 'firstPlanChooser'}
                          onToggle={() => toggleChooser('firstPlanChooser')}
                          onSelect={handleChangeFirstPlan}
                          onSlotSwitch={handleSlotSwitch}
                          topOffset={compareByDiscipline ? 75 : 0}
                          isSlotActive={slotsVisible['first']}
                        />

                        <PlanChooser
                          label={secondTitle}
                          firstColor='#5676fc'
                          secondColor='#E74C3C'
                          items={activePlans}
                          activeFirstPlanId={secondPlan?.id}
                          activeSecondPlanId={firstPlan?.id}
                          isOpen={openChooser === 'secondPlanChooser'}
                          onToggle={() => toggleChooser('secondPlanChooser')}
                          onSelect={handleChangeSecondPlan}
                          topOffset={compareByDiscipline ? 110 : 75}
                          onSlotSwitch={handleSlotSwitch}
                          source='second'
                          isSlotActive={slotsVisible['second']}
                        />
                      </>
                    )}
                  </div>
                }
              >
                <Tooltip text={__('plans.tooltip.compare_plans')}>
                  <div className={styles.comparePlans}>
                    <span>
                      {firstPlan?.title} / {secondPlan?.title}
                    </span>

                    <ArrowDownSmallIcon />
                  </div>
                </Tooltip>
              </Dropdown>
            </div>

            <div className={styles.separator} />

            {isSafari && (
              <Tooltip text='Compare tool is not available in Safari browser'>
                <CloseMediumIcon />
              </Tooltip>
            )}
            {!isSafari && (
              <Tooltip text={__('plans.tooltip.icon.close-compare-view')}>
                <CloseMediumIcon onClick={_toggleCompareTool} />
              </Tooltip>
            )}

            {/* <div className={styles.separator} />

            <Tooltip text={__('plans.tooltip.icon.plan-properties')}>
              <InfoPositiveIcon onClick={onInfoIconClick} />
            </Tooltip> */}
          </div>
        </div>
      </div>
      {/* Table */}
      <div className={styles.content}>
        <DualViewer
          leftPlan={firstPlan}
          rightPlan={secondPlan}
          showLeft={slotsVisible.first}
          showRight={slotsVisible.second}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
    task_table: state.table['all_tasks'],
    table: state.table['working_set_plans'],
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.working_set_plans/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(subscribe(Localization, 'localization')(ComparePlans))
);
